<template>
  <form @submit="onSubmit">
    <slot />
  </form>
</template>

<script setup lang="ts">
const props = defineProps<{
  onPost: (query: string, event: SubmitEvent) => void;
}>();

function onSubmit(event: Event) {
  event.preventDefault();

  const formData = new FormData(event.target as HTMLFormElement);
  // The Vue 2 version relied on FormData.forEach's (value, key) argument order
  // while naming the parameters (key, value) - correct output, misleading code.
  const query = new URLSearchParams(formData as unknown as Record<string, string>).toString();

  props.onPost(query, event as SubmitEvent);
}
</script>
